import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import { BIKES } from '../../constants/routes';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import BikeIcon from '../Icon/BikeIcon';
import { putRenterBike } from '../../store/bikes/actions';
import { KOBOO_LIGHT_OTHER_BLUE, KOBOO_OTHER_BLUE } from '../../constants/colors';
import { getBikeState } from '../../services/BikeService';

const styles = () => (
  {
    fabProgress: {
      color: 'primary',
      position: 'absolute',
      top: -6,
      left: -6,
      zIndex: 1,
    },
    row_container: {
      backgroundColor: KOBOO_LIGHT_OTHER_BLUE + " !important",
      '&:hover': {
        backgroundColor: KOBOO_OTHER_BLUE + " !important",
        color: 'white !important'
      }
    },
  }
);

export class BikeRow extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      sendingBikeId: '',
      progressPosition: 0,
      role: ROLE_USER,
      open: false,
    };
  }

  static propTypes = {
    classes: PropTypes.object.isRequired,
    bike: PropTypes.object.isRequired,
    isInBikePage: PropTypes.bool.isRequired,
  };

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = {
        ...newState,
        role,
      };
    }

    if (!props.sending && state.sendingBikeId) {
      newState = {
        ...newState,
        sendingBikeId: null,
      };
    }
    return newState;
  }

  handleClickSwitchActivateBike = (event, bike) => {
    this.setState({
      sendingBikeId: bike.id,
      progressPosition: 0,
    });
    this.props.putRenterBike(
      this.props.authUser.ma, bike.id,
      {
        is_activate: !bike.is_activate,
      },
    );
    event.preventDefault();
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClickAvailableBike = (event, bike) => {
    this.setState({
      sendingBikeId: bike.id,
      progressPosition: 2,
    });
    this.props.putRenterBike(
      this.props.authUser.ma, bike.id,
      {
        is_available: true,
      },
    );
    event.preventDefault();
  };

  render() {
    const {
      bike,
      classes,
      isInBikePage,
    } = this.props;

    const {
      sendingBikeId,
      progressPosition,
      role,
    } = this.state;

    let lostBike = (!bike.is_available && !bike.rents_in_progress);

    return (
      <TableRow
        className={bike.siteType
          ? classes.row_container
          : null}
        key={bike.id}
        hover
        tabIndex={-1}
      >
        <TableCell>
          <div className={classes.wrapper}>
            {bike.number}
            <Tooltip title={bike.is_activate
              ? 'Désactiver'
              : 'Activer'}>
              <IconButton
                aria-label="update"
                onClick={event => this.handleClickSwitchActivateBike(event, bike)}
              >
                <BikeIcon
                  id={'switch_activate'}
                  color={bike.is_activate
                    ? 'primary'
                    : 'secondary'}
                />
                {this.props.sending && sendingBikeId === bike.id && progressPosition === 0 &&
                <CircularProgress size={58} className={classes.fabProgress} />}
              </IconButton>
            </Tooltip>
          </div>
        </TableCell>
        <TableCell>{bike.padlock_number}</TableCell>
        {role === ROLE_ADMIN
        && isInBikePage
        && <TableCell>{bike.renterName}</TableCell>}
        <TableCell>{bike.siteName}</TableCell>
        <TableCell>
          <span id={'bike_state'}>{getBikeState(bike)}</span>
          {lostBike &&
          <Tooltip title="Rendre le vélo disponible">
            <IconButton
              aria-label="update"
              onClick={event => this.handleClickAvailableBike(event, bike)}
            >
              <BikeIcon
                id={'set_available'}
                color="primary"
              />
              {this.props.sending && sendingBikeId === bike.id && progressPosition === 2 &&
              <CircularProgress size={58} className={classes.fabProgress} />}
            </IconButton>
          </Tooltip>
          }
        </TableCell>
        <TableCell>{bike.mac_address}</TableCell>
        <TableCell>{bike.rfid}</TableCell>
        <TableCell>
          {bike.type
            ? 'Enfant'
            : 'Adulte'}
        </TableCell>
        <TableCell>
          {bike.is_electric
            ? 'Électrique'
            : 'Mécanique'}
        </TableCell>
        <TableCell padding="checkbox">
          <Tooltip title="Modifier">
            <IconButton
              aria-label="update"
              component={Link}
              to={`${BIKES}/${bike.id}`}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
    sending: state.bikes.sending,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { putRenterBike }),
)(BikeRow);



// WEBPACK FOOTER //
// ./src/components/Bike/BikeRow.jsx